import { Box, Typography } from '@mui/material';
import { TokenUsageMetadata } from 'api/model';
import { FONT_MONO } from 'themes/tokens';

type TokenUsageDisplayProps = {
  tokenUsage: TokenUsageMetadata;
  title?: string;
};

type Row = { label: string; value: string; emphasize?: boolean };

const TokenUsageDisplay = ({ tokenUsage, title }: TokenUsageDisplayProps) => {
  const rows: Row[] = [
    { label: 'Prompt tokens', value: tokenUsage.prompt_tokens.toLocaleString() },
    ...(tokenUsage.cached_prompt_tokens && tokenUsage.cached_prompt_tokens > 0
      ? [{ label: 'Cached prompt tokens', value: tokenUsage.cached_prompt_tokens.toLocaleString() }]
      : []),
    { label: 'Completion tokens', value: tokenUsage.completion_tokens.toLocaleString() },
    { label: 'Total tokens', value: tokenUsage.total_tokens.toLocaleString(), emphasize: true },
    { label: 'Total cost', value: `$${tokenUsage.total_cost.toFixed(5)}`, emphasize: true },
  ];

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minWidth: 300 }}>
      {title && <Typography sx={{ fontWeight: 700, fontSize: '1rem', mb: 0.5 }}>{title}</Typography>}
      {rows.map((row, index) => (
        <Box
          key={row.label}
          sx={(theme) => ({
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 3,
            py: 1,
            borderTop: index === 0 ? 'none' : `1px solid ${theme.palette.divider}`,
          })}
        >
          <Typography sx={{ color: 'text.secondary', fontWeight: row.emphasize ? 700 : 500 }}>{row.label}</Typography>
          <Typography
            sx={(theme) => ({
              fontFamily: FONT_MONO,
              fontWeight: row.emphasize ? 700 : 600,
              color: row.emphasize ? theme.palette.primary.light : theme.palette.text.primary,
            })}
          >
            {row.value}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export default TokenUsageDisplay;
